import { useMutation } from '@tanstack/react-query'
import { inviteCompanyMember } from 'api/company'
import { useInvalidateCompanyPendingInvites } from './useCompanyPendingInvites'
import { useAuthContext } from 'components/auth'

export function useInviteCompanyMemberMutation(options?: {
  onSuccess?: () => void
  onError?: (err: Error) => void
}) {
  const { onSuccess, ...otherOptions } = options ?? {}
  const { company } = useAuthContext()
  const { invalidate: invalidatePendingInvites } =
    useInvalidateCompanyPendingInvites()

  return useMutation({
    mutationFn: ({
      email,
      rolePermissionId,
    }: {
      email: string
      rolePermissionId: number
    }) => {
      if (!company) {
        throw new Error('Company not found')
      }

      return inviteCompanyMember(company.id, email, rolePermissionId)
    },
    onSuccess: () => {
      invalidatePendingInvites()
      if (onSuccess) onSuccess()
    },
    ...otherOptions,
  })
}
